import React from "react"
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import PermPhoneMsgTwoToneIcon from '@mui/icons-material/PermPhoneMsgTwoTone';

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

 render() {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="level">
            <div className="level-left">
              <div className="level-item">  
                <EmailTwoToneIcon />
                <span style={{marginLeft: '5px'}}>info@psybit.si</span>
              </div>
              <div className="level-item">
                <PermPhoneMsgTwoToneIcon />
                <span style={{marginLeft: '5px'}}>+386 41 335 221</span>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
                PsyBit 
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
};

export default Footer;
